import React from 'react'
import { Form, Modal, Input } from 'antd'
import { compose } from 'recompose'
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl'

const TruemoneyModal = compose(
  injectIntl,
  Form.create()
)(({
  amount,
  visible,
  loading: paymentLoading,
  onClose,
  onSubmit,
  form: { getFieldDecorator, validateFields }
}) => {
  const handleSubmit = e => {
    e.preventDefault()
    validateFields(async (err, data) => {
      console.error({ err, data })
      if (err) {
        console.error(err)
        return
      }
      const { mobileNumber } = data
      return onSubmit({ amount, mobileNumber })
    })
  }

  return <Modal
    title={<FormattedMessage id="paymentMethod.omise_truemoney" defaultMessage="TrueMoney Wallet" />}
    visible={visible}
    onOk={handleSubmit}
    okText={<FormattedMessage id="app.payRequest.amount" values={{ amount: <FormattedNumber value={amount} /> }} />}
    onCancel={onClose}
    confirmLoading={paymentLoading}
    width={480}
  >
    <Form layout="vertical" >
      <Form.Item
        label={<FormattedMessage id="paymentMethod.truemoneyMobileNumber" defaultMessage="TrueMoney Wallet mobile number" />}
        labelCol={{
          xs: { span: 24 },
          sm: { span: 12 }
        }}
        wrapperCol={{
          xs: { span: 24 },
          sm: { span: 12 }
        }}
        extra={<FormattedMessage id="paymentMethod.truemoneyMobileNumberExtra" defaultMessage="10 digits mobile number (TrueMoney Wallet ID)" />}
      >
        {getFieldDecorator('mobileNumber', {
          rules: [{
            required: true,
            message: <FormattedMessage id="paymentMethod.truemoneyMobileRequired" defaultMessage="Please enter TrueMoney Wallet mobile number" />
          }, {
            pattern: /^\d{10}$/,
            message: <FormattedMessage id="paymentMethod.truemoneyMobileInvalid" defaultMessage="Please enter 10 digits mobile number" />
          }]
        })(
          <Input pattern="^\d{10}$" />
        )}
      </Form.Item>
    </Form>
  </Modal>
})

export default TruemoneyModal



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseTruemoney/TruemoneyModal.js